"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_exception_1 = require("./exceptions/validation-exception");
const is_validation_result_1 = require("./type-guards/is-validation-result");
/**
 * @see validateType
 * @template T
 * @param value
 * @param {ValidateFunctionAsync} validator
 * @param {...ValidateFunctionAsync} additionalValidators
 * @returns {Promise<T>}
 */
exports.validateTypeAsync = async (value, validator, ...additionalValidators) => {
    const validators = [validator].concat(additionalValidators);
    for (const validate of validators) {
        const result = await validate(value);
        if (is_validation_result_1.isValidationResult(result) && !result.valid) {
            throw new validation_exception_1.ValidationException(result.details);
        }
        else if (result === false) {
            throw new validation_exception_1.ValidationException(`'${value}' is not valid.`);
        }
    }
    return value;
};
//# sourceMappingURL=validate-type-async.js.map